export const samsarLangSettings = {
  digitalTwinSingleLabel: "inventory:tabs.device.single_label",
  digitalTwinLabel: "inventory:tabs.device.label",
  digitalTwinAddResource: "inventory:tabs.device.add_resource",
};
